export const SSO_API_KEY = import.meta.env.VITE_APP_SSO_API_KEY;
export const SSO_DOMAIN_URL = import.meta.env.VITE_APP_SSO_DOMAIN_URL;
export const SSO_CLIENT_ID = import.meta.env.VITE_APP_SSO_CLIENT_ID;
export const SSO_REDIRECT_URL = import.meta.env.VITE_APP_SSO_REDIRECT_URL;
export const GIGYA_API_KEY = import.meta.env.VITE_GIGYA_KEY;
export const SSO_SYNDICATE = import.meta.env.VITE_PROJECT_SSO_SUNDICATE;
